import { Paper, Table, TableBody, TableContainer } from "@mui/material";

import LoadingIndicator from "../../../Common/LoadingIndicator/LoadingIndicator";
import { SETTLEMENT_STYLES } from "../../style/styles";

import OtherLiensBalanceListItem from "./OtherLiensBalanceListItem";
import OtherLiensBalanceTableHeader from "./OtherLiensBalanceTableHeader";

export default function OtherLiensBalanceTable({
  data = [],
  isLoading,
  deductionTypeDisplayMap,
  onEdit,
  onDelete,
  canEdit = false,
  canDelete = false,
}) {
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data.length) {
    return (
      <div className="flex min-h-0 flex-1">
        <div
          className="flex h-full min-h-[220px] w-full flex-1 items-center justify-center rounded-[12px] px-6 py-5 text-center text-base font-semibold"
          style={SETTLEMENT_STYLES.emptyStateCard}
        >
          Nothing To Show
        </div>
      </div>
    );
  }

  return (
    <TableContainer component={Paper} sx={SETTLEMENT_STYLES.scrollbarSx}>
      <Table stickyHeader aria-label="other liens and balance table">
        <OtherLiensBalanceTableHeader showActions={canEdit || canDelete} />
        <TableBody>
          {data.map((expense) => (
            <OtherLiensBalanceListItem
              key={expense.pk || expense.id}
              data={expense}
              deductionTypeDisplayMap={deductionTypeDisplayMap}
              onEdit={onEdit}
              onDelete={onDelete}
              canEdit={canEdit}
              canDelete={canDelete}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
